import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { mediaQuery } from '@lacedltd/laced-components'

export const ActionContainer = styled.div({
  display: 'flex',
  marginTop: tokens.spacing[7],
  gap: tokens.spacing[5],
  padding: `0 ${tokens.spacing[6]}`,
  flexDirection: 'column',
  justifyContent: 'flex-end',

  button: {
    '&:first-of-type': {
      order: '2'
    }
  },

  [mediaQuery.m.min]: {
    padding: 0
  },

  [mediaQuery.s.min]: {
    flexDirection: 'row',
    gap: tokens.spacing[7],

    button: {
      '&:first-of-type': {
        order: 'initial'
      },

      '&:last-of-type': {
        width: '50%'
      }
    }
  }
})

export const Card = styled.div({
  background: tokens.color.yeezy[0],
  padding: `${tokens.spacing[6]} ${tokens.spacing[6]}`,
  display: 'flex',
  flexDirection: 'column',

  [mediaQuery.m.min]: {
    padding: tokens.spacing[8]
  }
})

export const Link = styled.a<{ underline?: boolean }>(({ underline }) => ({
  textDecoration: underline ? 'underline' : 'none',
  textUnderlineOffset: tokens.spacing[2]
}))

export const Underline = styled.span({
  textDecoration: 'underline'
})
